import * as React from 'react';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { observer } from 'mobx-react';
const styles = require('./nativeAdItemPreLoading.scss');
@observer
export default class NativeAdPreloadingStubElement extends React.Component<{}, {}> {
    render() {
        const nativeAdPreLoadStaticContainerStyle = isMiniFeatureEnabled(
            'miniAE-NativeUX-treatment'
        )
            ? styles.nativeAdPreLoadStaticContainerExp
            : styles.nativeAdPreLoadStaticContainer;
        return <div className={nativeAdPreLoadStaticContainerStyle} />;
    }
}
